module.exports = __webpack_public_path__ + "static/img/8bg_4.ee09ce8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_4.png
// module id = 755
// module chunks = 1